import { HorizontalGrey } from './horizontal/horizontal-grey';
import { HorizontalColor } from './horizontal/horizontal-color';
import { VerticalGrey } from './vertical/vertical-grey';
import { VerticalColor } from './vertical/vertical-color';

export function getSocialShareTemplate(template) {
  switch(template) {
    case 'horizontal-grey': return HorizontalGrey;
    case 'horizontal-color': return HorizontalColor;
    case 'vertical-grey': return VerticalGrey;
    case 'vertical-color': return VerticalColor;
    default: return HorizontalGrey;
  }
}